export default `
    <div class="#= data.containerClasses || "" # #= data.bsc || "" #">
        <div class="editor-overlay" style="display: none;"></div>
        <textarea id="#= data.id #" class="#= data.classes #" style="height: 178px;"></textarea>
    </div>
`;
